import { environment } from 'src/environments/environment.dev';

export const URL_SERVICIOS = environment.URL_SERVICIOS;
export const URL_DOCS = environment.URL_DOCS;
export const URL_SERVICIOS_SOCKET = environment.URL_SERVICIOS_SOCKET;
export const ENVIRONMENT = environment.ENVIRONMENT;